
import { tracs_api } from "../../services/api.interceptor";
import { DataAttribute, EditorType } from "../interfaces/sharedmodels";
import { Job } from "../interfaces/tablegenmodels";

class ItsoService{
    getdatatables(){
        let toc=null;

        let tocfromStorage=localStorage.getItem('Toc');
        if(tocfromStorage){
            toc=JSON.parse(tocfromStorage);
        }
        return tracs_api
        .post(process.env.REACT_APP_DATAMANAGEMENT_API+ "Itso/GetDataTables?tocId="+(toc?toc?.Id:0));
    }

    getoutputTables(){
        let toc=null;

        let tocfromStorage=localStorage.getItem('Toc');
        if(tocfromStorage){
            toc=JSON.parse(tocfromStorage);
        }
        return tracs_api
        .post(process.env.REACT_APP_DATAMANAGEMENT_API+ "Itso/GetOutputTables?tocId="+(toc?toc?.Id:0));
    }

    gettableVersions(tableId:number,nlc:number|null){
        let toc=null;

        let tocfromStorage=localStorage.getItem('Toc');
        if(tocfromStorage){
            toc=JSON.parse(tocfromStorage);
        }
        let nlcVal=nlc== null?"":nlc?.toString();
        return tracs_api
        .post(process.env.REACT_APP_DATAMANAGEMENT_API+ "Itso/GetVersions?tocId="+(toc?toc?.Id:0)+"&tableId="+tableId
        +"&nlc="+nlcVal);
    }

    getdata(tableId:number|undefined,nlcId:number|undefined,version:string,filterValues:DataAttribute[]|null=null,
        editorType:EditorType=EditorType.Table){
        let toc=null;
        let tocfromStorage=localStorage.getItem('Toc');
        if(tocfromStorage){
            toc=JSON.parse(tocfromStorage);
        }
        return tracs_api
        .post(process.env.REACT_APP_DATAMANAGEMENT_API+ "Itso/GetData",{TocId:(toc?toc?.Id:0),TableId:tableId,NlcId:nlcId,
            Version:version,FilterValues:filterValues,EditorType:editorType});
    }

    getOutputData(tableId:number|undefined,nlcId:number[]|undefined){
        let toc=null;
        let tocfromStorage=localStorage.getItem('Toc');
        if(tocfromStorage){
            toc=JSON.parse(tocfromStorage);
        }
        return tracs_api
        .post(process.env.REACT_APP_DATAMANAGEMENT_API+ "Itso/GetOutputData",{TocId:(toc?toc?.Id:0),TableId:tableId,NlcIds:nlcId});
    }

    getBuildOutputFolders(){
        let toc=null;
        let tocfromStorage=localStorage.getItem('Toc');
        if(tocfromStorage){
            toc=JSON.parse(tocfromStorage);
        }
        return tracs_api
        .post(process.env.REACT_APP_TABLEGEN_API+ "Itso/GetBuildOutputFolders?tocId="+(toc?toc?.Id:0));
    }

    initiateBuildJob(job:Job){
        let toc=null;
        let tocfromStorage=localStorage.getItem('Toc');
        if(tocfromStorage){
            toc=JSON.parse(tocfromStorage);
            job.TocId=toc.Id;
        }
        else{
            job.TocId=0;
        }
        return tracs_api
        .post(process.env.REACT_APP_TABLEGEN_API+ "Job/InitiateBuildJob",job);
    }

    updateTableData(data:any){
        let toc=null;
        let tocfromStorage=localStorage.getItem('Toc');
        if(tocfromStorage){
            toc=JSON.parse(tocfromStorage);
            data.TocId=toc.Id;
        }
        else{
            data.TocId=0;
        }
        return tracs_api
        .post(process.env.REACT_APP_DATAMANAGEMENT_API+ "Itso/UpdateTableData",data);
    }

    updateAcceptanceData(data:any){
        let toc=null;
        let tocfromStorage=localStorage.getItem('Toc');
        if(tocfromStorage){
            toc=JSON.parse(tocfromStorage);
            data.TocId=toc.Id;
        }
        else{
            data.TocId=0;
        }
        return tracs_api
        .post(process.env.REACT_APP_DATAMANAGEMENT_API+ "Itso/UpdateAcceptanceData",data);
    }

    updateFormData(data:any){
        let toc=null;
        let tocfromStorage=localStorage.getItem('Toc');
        if(tocfromStorage){
            toc=JSON.parse(tocfromStorage);
            data.TocId=toc.Id;
        }
        else{
            data.TocId=0;
        }
        return tracs_api
        .post(process.env.REACT_APP_DATAMANAGEMENT_API+ "Itso/UpdateFormData",data);
    }


    setCurrentVersion(version:string,tableId:number,remarks:string){
        let toc=null;
        let tocfromStorage=localStorage.getItem('Toc');
        if(tocfromStorage){
            toc=JSON.parse(tocfromStorage);
        }

        return tracs_api
        .post(process.env.REACT_APP_DATAMANAGEMENT_API+ "Itso/SetCurrentVersion",
        {TocId:(toc?toc?.Id:0),TableId:tableId,Version:version,Remarks:remarks});
    }

    
    getLogs(page:number,nlc:string,table:string,fromDate:Date|null,toDate:Date|null){
        let toc=null;
        let tocfromStorage=localStorage.getItem('Toc');
        if(tocfromStorage){
            toc=JSON.parse(tocfromStorage);
        }

        return tracs_api
        .post(process.env.REACT_APP_DATAMANAGEMENT_API+ "Itso/GetLogs",
            {TocId:(toc?toc?.Id:0),Page:page,TableId:table=="-99"?null:table,NlcId:nlc=="-99"?null:nlc,StartTime:fromDate,EndTime:toDate});
    }

}

export default new ItsoService();